/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Check_State_4Inputs */

const en_how_we_work_check_state_4 = /** @type {(inputs: How_We_Work_Check_State_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause & notify`)
};

const lv_how_we_work_check_state_4 = /** @type {(inputs: How_We_Work_Check_State_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apturēt un paziņot`)
};

/**
* | output |
* | --- |
* | "Pause & notify" |
*
* @param {How_We_Work_Check_State_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_check_state_4 = /** @type {((inputs?: How_We_Work_Check_State_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Check_State_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_check_state_4(inputs)
	return en_how_we_work_check_state_4(inputs)
});